import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import UpdateUser from "./UpdateUser";
import AddNewUser from "./AddNewUser";
import RedirectToAllCompanies from "../company/RedirectToAllCompanies";
import { useSelector } from "react-redux";

function AllUsers() {
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState([]);
  const { id } = useParams();
  const auth = useSelector((state) => state?.authenticationSlice);
  const userTypeId = auth?.userTypeId;

  const getAllUsers = async () => {
    setloading(true);
    const res = await handleGetRequest("user/all/" + id);
    setdata(res?.data);
    setloading(false);
  };

  const actionTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {userTypeId === 1 ||
          (userTypeId === "1" && (
            <UpdateUser
              data={rowData.user}
              getAllUsers={getAllUsers}
              companyId={id}
            />
          ))}
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    if (rowData?.user?.activeInactive === 1) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaCheck style={{ color: "green", marginRight: "5px" }} />
          <span>Active</span>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaTimes style={{ color: "red", marginRight: "5px" }} />
          <span>Inactive</span>
        </div>
      );
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []); // eslint-disable-line

  return (
    <>
      <div>
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <RedirectToAllCompanies />
            {userTypeId === 1 ||
              (userTypeId === "1" && (
                <AddNewUser companyId={id} getAllUsers={getAllUsers} />
              ))}
          </div>
          <DataTable
            header="All Users"
            scrollable
            scrollHeight="400px"
            style={{ minWidth: "50rem" }}
            tableStyle={{ minWidth: "50rem" }}
            dataKey="companyId"
            loading={loading}
            paginator
            rows={10}
            value={data}
            emptyMessage="No data found."
          >
            <Column filter field="user.name" header="Name" />
            <Column filter field="user.username" header="Username" />
            <Column filter field="roleName" header="Role" />

            <Column
              filter
              field="user.activeInactive"
              header="Status"
              body={statusTemplate}
            />
            <Column body={actionTemplate} header="Action" />
          </DataTable>
        </div>
      </div>
    </>
  );
}

export default AllUsers;
